import React from "react";
import { connect } from "react-redux";
import FilmalityCircularProgress from "../../../../shared/filmality-circular-progress";
import SetDressing from "./setDressing";
import Errors from "../../../../shared/errors";
import {
  OnboardingStep1ClassName,
  OnboardingStep2ClassName,
  OnboardingStep3ClassName,
  OnboardingStep4ClassName
} from "./ducks/reducer";
import Onboarding from '../../../../shared/onboarding/onboarding';
import confirm from "../../../../shared/modal/confirm";
import FilmanizeCheckbox from "../../../../shared/filmanize-checkbox";

function Overview(props) {
  const {
    overview,
    filmId,
    errors,
    warnings,
    onboardingSteps,
    aliasSetDressing,
    unaliasSetDressing,
    readOnly,
    setDressingsAcquiredPercentage,
    processingSetDressingIds,
    deleteMultipleSetDressings
  } = props;

  const [selectedSetDressingIds, setSelectedSetDressingIds] = React.useState<number[]>([]);

  const toggleSetDressingSelection = (setDressingId: number) => {
    setSelectedSetDressingIds(prev =>
      prev.includes(setDressingId)
        ? prev.filter(id => id !== setDressingId)
        : [...prev, setDressingId]
    );
  };

  const toggleSelectAll = () => {
    if (selectedSetDressingIds.length === overview.setDressings?.length) {
      setSelectedSetDressingIds([]);
    } else {
      setSelectedSetDressingIds(overview.setDressings?.map(s => s.id) || []);
    }
  };

  const deleteMultipleSetDressingsLocal = (filmId, selectedSetDressingIds) => {
    deleteMultipleSetDressings(filmId, selectedSetDressingIds)
    setSelectedSetDressingIds([]);
  }

  const handleDeleteSelected = () => {
    if (selectedSetDressingIds.length === 0) return;
    confirm(() => deleteMultipleSetDressingsLocal(filmId, selectedSetDressingIds), null, `Are you sure you want to delete ${selectedSetDressingIds.length} set dressing${selectedSetDressingIds.length !== 1 ? 's' : ''}?`, "Delete Set Dressings");
  };

  function Charts() {
    return (
      <div className="columns">
        <div
          className={`${OnboardingStep1ClassName} circular-progress column`}>
          <FilmalityCircularProgress
            percentage={setDressingsAcquiredPercentage}
            title="Set Dressings Acquired"
          />
        </div>
      </div>
    );
  }

  function PropsList() {
    const allSelected = selectedSetDressingIds.length === overview.setDressings?.length && overview.setDressings?.length > 0;

    return (
      <>
        <table className={`${OnboardingStep3ClassName} table`}>
          <thead>
            <tr>
              {!readOnly && (
                <th>
                  <FilmanizeCheckbox
                    checked={allSelected}
                    onChange={toggleSelectAll}
                  />
                </th>
              )}
              <th>Name</th>
              <th>Quantity</th>
              <th>Quantity Acquired</th>
              <th>Acquisition Method</th>
            </tr>
          </thead>
          <tbody>
            {(overview.setDressings || []).map((setDressing, index) => {
              return (
                <SetDressing
                  key={index}
                  index={index}
                  prop={setDressing}
                  filmId={filmId}
                  readOnly={readOnly}
                  aliasSetDressing={aliasSetDressing}
                  unaliasSetDressing={unaliasSetDressing}
                  processingSetDressingIds={processingSetDressingIds}
                  isSelected={selectedSetDressingIds.includes(setDressing.id)}
                  onToggleSelect={() => toggleSetDressingSelection(setDressing.id)} />
              );
            })}
          </tbody>
        </table>
      </>
    );
  }


  return (
    <div>
      <div className="columns">
        <div
          className={`${OnboardingStep1ClassName} circular-progress column`}>
          <FilmalityCircularProgress
            percentage={setDressingsAcquiredPercentage}
            title="Set Dressings Acquired"
          />
        </div>
      </div>
      {errors && <Errors errors={errors} />}
      {warnings && <Errors errors={warnings} isWarning={true} />}
      <div className={OnboardingStep2ClassName}>
        <div className="columns">
          <div className="column">
            <PropsList />
          </div>
        </div>
      </div>
      <div className="mt-1 buttons">
        {!readOnly && overview.setDressings?.length > 0 && (
          <button
            className="button is-danger"
            onClick={handleDeleteSelected}
            disabled={selectedSetDressingIds.length === 0}
          >
            Delete Selected ({selectedSetDressingIds.length})
          </button>
        )}
      </div>
      <Onboarding onboardingSteps={onboardingSteps} section="Set Dressing Overview" />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    onboardingSteps:
      state.setDressingsOverviewState.onboardingSteps
  };
}

export default connect(mapStateToProps, {
})(Overview);
